import { render, staticRenderFns } from "./SuccessOrder.vue?vue&type=template&id=30d1b60c&"
import script from "./SuccessOrder.vue?vue&type=script&lang=js&"
export * from "./SuccessOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports